import React from 'react';

import App360Index from './360Mode/IndexView/IndexView';
import App360AppartmentView from './360Mode/AppartmentView/AppartmentView';
import AppVideoIndex from './VideoMode/App';
import Login from './Login';

import { Route } from 'react-router-dom';
// import { AnimatedRoute, AnimatedSwitch } from 'react-router-transition';
import { connect } from 'react-redux'

const Router = ({ rootClassEffect, scrollForm, scrollHeader, scrollWebsite }) => (
    <div className={"kozySlider " + rootClassEffect}>
        <Route exact path="/" render={ (props) => { return <AppVideoIndex {...props} scrollWebsite={scrollWebsite} /> } } />

        <Route exact path="/360" render={ (props) => { return <App360Index {...props} scrollWebsite={scrollWebsite} /> } } />

        <Route exact path="/360/:appartmentId/:roomId" render={ (props) => { return <App360AppartmentView {...props} scrollWebsite={scrollWebsite} /> } } />

        <Route exact path="/videos" render={ (props) => { return <AppVideoIndex {...props} scrollWebsite={scrollWebsite} /> } } />

        <Route exact path="/videos/:videoId" render={ (props) => { return <AppVideoIndex {...props} scrollForm={scrollForm} scrollHeader={scrollHeader} /> } } />

        <Route exact path="/login" component={Login} />
    </div>
)

export { Router };
export default connect(
    (state) => state.app
)(Router);



// WEBPACK FOOTER //
// ./src/components/router.js